export const customDomainHeaderTypes = ['sidebar', 'top'] as const
export type CustomDomainHeaderType = typeof customDomainHeaderTypes[number]

export const customDomainHeaderDisplays = ['always', 'home', 'never'] as const
export type CustomDomainHeaderDisplay =
  typeof customDomainHeaderDisplays[number]

export const customDomainMainMenuContents = [
  'only_guild_menu',
  'team_switcher_and_guild_menu',
  'team_switcher_and_team_menu',
] as const
export type CustomDomainMainMenuContent =
  typeof customDomainMainMenuContents[number]

export const textStyles = [
  'cards',
  'textShadow',
  'scrim',
  'glass',
  'outline',
] as const
export type TextStyle = typeof textStyles[number]

export const customDomainHeaderTitleTypes = [
  'guildName',
  'teamDescription',
  'teamName',
  'none',
] as const
export type CustomDomainHeaderTitleType =
  typeof customDomainHeaderTitleTypes[number]

export const customDomainGuildHeaderTitleTypes = ['guildName', 'none'] as const

export const customDomainHomepageImageStyles = ['solid', 'fading'] as const
export type CustomDomainHomepageImageStyle =
  typeof customDomainHomepageImageStyles[number]

export type CustomDomainHeaderConfig = Partial<{
  headerType: CustomDomainHeaderType
  headerDisplay: CustomDomainHeaderDisplay
  textStyle: TextStyle
  transparentCards: boolean
  titleType: CustomDomainHeaderTitleType
  subtitleType: CustomDomainHeaderTitleType
  noImage: boolean
  height: number
  backgroundImage: string
  hideBanner: boolean
  hideLinks: boolean
  hideOverviewMenuItem: boolean
  mainMenuContent: CustomDomainMainMenuContent
  homepageImageStyle: CustomDomainHomepageImageStyle
}>
